import React from 'react';
import { BadgeAlt as Badge } from '@cargomatic/ui';
import { cn } from 'utils/ui/classes';
function normalize(equipmentType) {
    return equipmentType.toLowerCase().replace(/[\s_-]+/g, '');
}
function getColor(equipmentType) {
    switch (normalize(equipmentType)) {
        case 'container':
        case 'equipmentid':
            return 'bg-blue-100 text-blue-800 border-blue-300';
        case 'chassis':
        case 'chassisnumber':
            return 'bg-purple-100 text-purple-800 border-purple-300';
        case 'trailer':
        case 'trailernumber':
            return 'bg-gray-100 text-gray-800 border-gray-300';
        default:
            return 'bg-gray-100 text-gray-800 border-gray-300';
    }
}
function getLabel(equipmentType) {
    switch (normalize(equipmentType)) {
        case 'container':
        case 'equipmentid':
            return 'Container';
        case 'chassis':
        case 'chassisnumber':
            return 'Chassis';
        case 'trailer':
        case 'trailernumber':
            return 'Trailer';
        default:
            return equipmentType;
    }
}
export default function EquipmentTypeBadge({ className = '', equipmentType, label, }) {
    if (!equipmentType)
        return null;
    return (React.createElement(Badge, { variant: "outline", className: cn('whitespace-nowrap self-start shrink-0 grow-0', getColor(equipmentType), className) }, label !== null && label !== void 0 ? label : getLabel(equipmentType)));
}
